import { render, staticRenderFns } from "./EventShowPage.vue?vue&type=template&id=5982821c&scoped=true&"
import script from "./EventShowPage.vue?vue&type=script&lang=js&"
export * from "./EventShowPage.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EventShowPage.vue?vue&type=style&index=1&id=5982821c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982821c",
  null
  
)

export default component.exports